<div class="it-page" *ngIf="vm$ | async as vm" [attr.data-theme]="(theme$ | async) ?? 'dark'" [style.--resp-w.px]="facade.getResponseWidth()">
	<div class="it-shell" *ngIf="vm.canUseIntegrationTester; else noAccess" [class.it-locked]="!vm.selectedLoginId">

		<it-topbar [theme]="theme$ | async" [integrationCrumb]="getIntegrationCrumb(vm)" [requestName]="vm.activeRequest?.name || 'Request'" (toggleTheme)="facade.toggleTheme()" (startTour)="facade.setResponseTab('body')">
		</it-topbar>

		<it-context-bar [vm]="vm" (integrationChanged)="facade.setIntegration($event)" (loginChanged)="facade.setLogin($event)" (testLogin)="testLogin()">
		</it-context-bar>

		<div class="it-panels">
			<div class="it-lock-overlay" *ngIf="!vm.selectedLoginId" aria-hidden="true">
				<div class="it-lock-card">
					Select a login to enable editing and sending requests.
				</div>
			</div>


			<it-sidebar [vm]="vm" (requestSearchChanged)="facade.setRequestSearch($event)" (collectionChanged)="facade.setActiveCollection($event)" (setActiveRequest)="facade.setActiveRequest($event)" (navigateToRequest)="facade.navigateTo($event.colId, $event.reqId)"
				(addCollection)="addCollection()" (renameCollection)="renameCollection(vm)" (deleteCollection)="deleteCollection()" (addRequest)="addRequest()" (duplicateRequest)="facade.duplicateActiveRequest()" (deleteRequest)="deleteRequest()" (reorderWithinCollection)="facade.reorderRequestWithinCollection($event.colId, $event.movingReqId, $event.targetReqId, $event.place)"
				(moveToCollection)="facade.moveRequestToCollection($event.fromColId, $event.toColId, $event.reqId)" (moveToEnd)="facade.moveRequestToEndOfCollection($event.colId, $event.reqId)">
			</it-sidebar>

			<div class="it-mid" [style.--resp-w.px]="facade.getResponseWidth()">
				<it-editor [vm]="vm" (send)="send()" (updateRequest)="facade.updateActiveRequest($event)" (setSubTab)="facade.setSubTab($event)" (addParam)="facade.addParam()" (updateParam)="facade.updateParam($event.index, $event.patch)" (removeParam)="facade.removeParam($event.index)"
					(clearParams)="facade.clearParams()" (addHeader)="facade.addHeader()" (addCommonHeaders)="facade.addCommonHeaders()" (updateHeader)="facade.updateHeader($event.index, $event.patch)" (removeHeader)="facade.removeHeader($event.index)" (clearHeaders)="facade.clearHeaders()"
					(formatBody)="facade.formatBody()" (clearBody)="facade.clearBody()">
				</it-editor>

				<it-splitter (resizeWidth)="facade.setResponseWidth($event)">
				</it-splitter>

				<it-response-pane [vm]="vm" [findQuery]="vm.findQuery" [renderedBodyHtml$]="renderedBodyHtml$" [pathTreeItems$]="pathTreeItems$" (setResponseTab)="facade.setResponseTab($event)" (copyBody)="facade.copyResponseBody()" (findChanged)="facade.setFindQuery($event)"
					(setFindIndex)="facade.setFindIndex($event)" (clearFind)="facade.clearFind()" (gridPathChanged)="facade.setGridPath($event)" (clearResponseCache)="facade.clearResponseCache()">
				</it-response-pane>
			</div>
		</div>
	</div>

	<ng-template #noAccess>
		<div class="it-card">
			<div class="it-header">
				<div class="it-title">Integration Tester</div>
			</div>
			<div class="it-empty-big">No access permitted.</div>
		</div>
	</ng-template>
</div>

<app-tour-overlay></app-tour-overlay>
